export type SecurityAuditAction =
  | 'login_success'
  | 'login_failed'
  | 'login_blocked'
  | 'login_mfa_failed'
  | 'login_mfa_success'
  | 'password_changed'
  | 'password_reset_requested'
  | 'password_reset_completed'
  | 'mfa_enrolled'
  | 'mfa_disabled'
  | 'permission_role_updated'
  | 'permission_user_override_updated'
  | 'export_generated';

export interface SecurityAuditLogItem {
  id: string;
  organizationId: string;
  userId: number | null;
  userEmail: string | null;
  action: SecurityAuditAction;
  ip: string;
  userAgent: string | null;
  metadata: Record<string, unknown> | null;
  at: string;
}

export interface SecurityAuditListResponse {
  items: SecurityAuditLogItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PasswordPolicy {
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireDigit: boolean;
  requireSpecialChar: boolean;
  expirationDays: number | null;
  maxFailedAttempts: number;
  lockoutMinutes: number;
  mfaRequiredForRoles: string[];
}

export interface MfaStatus {
  enabled: boolean;
  requiredByPolicy: boolean;
  canDisable: boolean;
}

export interface MfaSetupResponse {
  otpauthUri: string;
  secret: string;
}

export const SECURITY_AUDIT_ACTION_LABELS: Record<SecurityAuditAction, string> = {
  login_success: 'Inicio de sesión exitoso',
  login_failed: 'Inicio de sesión fallido',
  login_blocked: 'Cuenta bloqueada',
  login_mfa_failed: 'MFA fallido en login',
  login_mfa_success: 'MFA verificado en login',
  password_changed: 'Contraseña cambiada',
  password_reset_requested: 'Solicitud de reset',
  password_reset_completed: 'Reset completado',
  mfa_enrolled: 'MFA activado',
  mfa_disabled: 'MFA desactivado',
  permission_role_updated: 'Permisos de rol actualizados',
  permission_user_override_updated: 'Override de permisos de usuario',
  export_generated: 'Exportación generada',
};
